<template>
  <div class="consent-insured-page">
    <div class="consent-information-form-container">
      <div class="consent-title">การยืนยันการทำประกันภัย</div>

      <div class="consent-description">
        ข้าพเจ้า
        <span class="highlight-word">{{ insuredInformation.name }}</span>
        ขอยืนยันการทำประกันภัยสุขภาพแผน
        <span class="highlight-word">{{ insurancePlanName }}</span> ในโครงการ
        <span class="highlight-word">ttb health care plus</span>
        และข้าพเจ้าขอยืนยันว่าได้ตอบข้อแถลงสุขภาพของผู้ขอ เอาประกันภัยตามความเป็นจริงทุกประการ
      </div>
      <div class="consent-remark">
        นอกจากนี้ ข้าพเจ้ายินยอมให้บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน)
        ร้องขอหรือทราบข้อมูลหรือถ่ายสำเนาจากบันทึกประวัติการรักษาพยาบาล
        ประวัติสุขภาพของข้าพเจ้าจากแพทย์ โรงพยาบาล สถานพยาบาล เวชคลินิก หรือองค์กรอื่นใด
        ที่มีบันทึกหรือทราบเรื่องเกี่ยวกับสุขภาพของข้าพเจ้าได้ และข้าพเจ้ายินยอมให้บริษัทจัดเก็บ ใช้
        และเปิดเผยข้อเท็จจริงเกี่ยวกับสุขภาพและข้อมูลผู้เอาประกันภัยต่อสำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย
        เพื่อประโยชน์ในการกำกับดูแลธุรกิจประกันภัย
      </div>
      <div class="consent-signature-container">
        <div class="consent-signature-title">กรุณาลงนาม</div>
        <vueSignature
          class="consent-signature-section"
          ref="signature"
          :sigOption="options"
          h="200px"
        />
        <div class="signature-clear-btn-container">
          <Button class="signature-clear-btn" type="info" @click.native="clearSignature">
            แก้ไข
          </Button>
        </div>
      </div>
      <div class="consent-submit-btn-container">
        <Button class="consent-submit-btn" @click.native="submitConsentInformation">ยืนยัน</Button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'

import Button from '@/components/Button'
import { convertBase64ToBlob } from '@/lib/services'

export default {
  name: 'ConsentInsured',
  props: ['application_id'],
  data() {
    return {
      insuredInformation: {},
      insurancePlanName: '',
      options: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: 'rgb(255, 255, 255)',
      },
    }
  },
  components: {
    Button,
  },
  mounted() {
    this.getApplicationInformation(this.application_id)
  },
  watch: {
    applicationInformation: {
      handler: function() {
        const insuredInformation = _.get(
          this.applicationInformation,
          'applicationInformation.insuredPerson',
          {},
        )

        const planName = _.get(
          this.applicationInformation,
          'applicationInformation.planPackageScheme.planName',
          '',
        )

        const {
          personId,
          title,
          firstname,
          lastname,
          ...restInsuredInformation
        } = insuredInformation

        const fullname = `${title.name || ''} ${firstname} ${lastname}`.trim()

        this.insuredInformation = {
          id: personId,
          name: fullname,
          ...restInsuredInformation,
        }
        this.insurancePlanName = planName
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['applicationInformation']),
  },
  methods: {
    ...mapActions(['getApplicationInformation', 'updateConsentInsuredInformation']),
    clearSignature() {
      this.$refs.signature.clear()
    },
    submitConsentInformation() {
      if (!this.$refs.signature.isEmpty()) {
        const consentImageData = this.$refs.signature.save()

        const imageBlock = consentImageData.split(';')
        const contentType = imageBlock[0].split(':')[1]
        const realData = imageBlock[1].split(',')[1]
        const blob = convertBase64ToBlob(realData, contentType)
        const FormImageData = new FormData()

        FormImageData.append('image', blob)

        this.updateConsentInsuredInformation(FormImageData)
      } else {
        this.$swal({
          type: 'error',
          title: 'กรุณาเซ็นต์ยืนยัน',
        })
      }
    },
  },
}
</script>

<style lang="scss">
.consent-insured-page {
  padding-top: 48px;

  .consent-information-form-container {
    background-color: #fff;
    margin: 0 auto;
    padding: 32px 48px;
    width: 80%;

    .consent-title {
      font-family: 'psl_kanda_extraregular', serif;
      font-size: 18px;
      line-height: 22px;
      margin-bottom: 12px;
      text-align: center;
    }

    .consent-description {
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 24px;
      text-indent: 50px;

      .highlight-word {
        font-family: 'psl_kanda_extraregular', serif;
      }

      .inform-text {
        margin-top: 24px;
      }

      &.combine-payment {
        .insured-information-section {
          .insured-information {
            text-indent: 32px;
          }
        }
      }
    }

    .consent-remark {
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 24px;
      text-indent: 50px;
    }

    .consent-signature-container {
      margin-bottom: 24px;
      position: relative;

      .consent-signature-title {
        font-family: 'psl_kanda_extraregular', serif;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 12px;
        text-align: center;
      }

      .consent-signature-section {
        border: 1px solid #c5c5c5;
        border-radius: 3px;
      }

      .signature-clear-btn-container {
        position: absolute;
        top: 35px;
        right: 5px;

        .signature-clear-btn {
          min-width: 60px;
        }
      }
    }

    .consent-submit-btn-container {
      text-align: center;
    }
  }
}
</style>
